import { Activity } from '../dtos/index';
import { ActivityView } from '../views/index';
import { MAP_ACTIVITY_TYPE } from './map-activity-type';

export const ACTIVITY_LIST = (activityDTO: Array<Activity> = []): Array<ActivityView> => {
	let results: Array<ActivityView> = [];
	if (activityDTO.length > 0) {
		activityDTO.map((activity) => {
			let row = {} as ActivityView;
			row.activityType = activity.activityType;
			row.amount = activity.amount;
			row.created = activity.created;
			row.message = MAP_ACTIVITY_TYPE(activity);
			results.push(row);
		});
	}
	return results;
};
